var _rect, _path, _path2, _g, _path3, _g2, _path4, _g3, _path5, _g4, _path6, _g5, _path7, _g6, _path8, _g7, _path9, _g8, _path0, _g9, _path1, _g0, _path10, _g1, _path11, _g10, _path12, _g11, _path13, _g12, _path14, _g13, _path15, _g14, _path16, _g15, _path17, _g16, _path18, _g17, _path19, _g18, _path20, _g19, _path21, _g20, _path22, _g21, _path23, _g22, _path24, _g23, _path25, _g24, _path26, _g25, _path27, _g26, _path28, _g27, _path29, _g28, _path30, _g29, _path31, _g30, _path32, _g31, _path33, _g32, _path34, _g33, _path35, _g34, _path36, _g35, _path37, _g36, _path38, _g37, _path39, _g38, _path40, _g39, _path41, _g40, _path42, _g41, _path43, _g42, _path44, _g43, _path45, _g44, _path46, _g45, _path47, _g46, _path48, _g47, _path49, _g48, _path50, _g49, _path51, _g50, _path52, _g51, _path53, _g52, _path54, _g53, _path55, _g54, _path56, _g55, _path57, _g56, _path58, _g57, _path59, _g58, _path60, _g59, _path61, _g60, _path62, _g61, _path63, _g62, _path64, _g63, _path65, _g64, _path66, _g65, _path67, _g66, _path68, _g67, _path69, _g68, _path70, _g69, _path71, _g70, _path72, _g71, _path73, _g72, _path74, _g73, _path75, _g74, _path76, _g75, _path77, _g76, _path78, _g77, _path79, _g78, _path80, _g79, _path81, _g80, _path82, _g81, _path83, _g82, _path84, _g83, _path85, _g84, _path86, _g85, _path87, _g86, _path88, _g87, _path89, _g88, _path90, _g89, _path91, _g90, _path92, _g91, _path93, _g92, _path94, _g93, _path95, _g94, _path96, _g95, _path97, _g96, _path98, _g97, _path99, _g98, _path100, _g99, _path101, _g100, _path102, _g101, _path103, _g102, _path104, _g103, _path105, _g104, _path106, _g105, _path107, _g106, _path108, _g107, _path109, _g108, _path110, _g109, _path111, _g110, _path112, _g111, _path113, _g112, _path114, _g113, _path115, _g114, _path116, _g115, _path117, _g116, _path118, _g117, _path119, _g118, _path120, _g119, _path121, _g120, _path122, _g121, _path123, _g122, _path124, _g123, _path125, _g124, _path126, _g125, _path127, _g126, _path128, _g127, _path129, _g128, _path130, _g129, _path131, _g130, _path132, _g131, _path133, _g132, _path134, _g133, _path135, _g134, _path136, _g135, _path137, _g136, _path138, _g137, _path139, _g138, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBackgroundStep1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 670,
    height: 900,
    viewBox: "0 0 670 900",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_914_18864)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.1,
    width: 670,
    height: 900,
    fill: "#5CFFE9"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_914_18864",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -512,
    y: 41,
    width: 2227,
    height: 1350
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1714.38 41H-512V1391H1714.38V41Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_914_18864)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_914_18864",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 60,
    y: 40,
    width: 23,
    height: 23
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M76.2739 40.9976L60.573 56.6921L66.8544 62.971L82.5553 47.2764L76.2739 40.9976Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_914_18864)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M71.5627 29.6963L49.2668 51.9832L71.5627 74.27L93.8585 51.9832L71.5627 29.6963Z",
    fill: "#32DCDC",
    fillOpacity: 0.2
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_914_18864",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 37,
    y: 64,
    width: 23,
    height: 23
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M52.7214 64.5437L37.0205 80.2383L43.3019 86.5171L59.0028 70.8225L52.7214 64.5437Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_914_18864)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M48.0102 53.2424L25.7144 75.5293L48.0102 97.8162L70.3061 75.5293L48.0102 53.2424Z",
    fill: "#32DCDC",
    fillOpacity: 0.2
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_914_18864",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 37,
    y: 40,
    width: 23,
    height: 23
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M43.3019 40.9985L37.0205 47.2773L52.7214 62.9719L59.0028 56.6931L43.3019 40.9985Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_914_18864)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M48.0104 29.6997L25.7146 51.9866L48.0104 74.2734L70.3063 51.9866L48.0104 29.6997Z",
    fill: "#32DCDC",
    fillOpacity: 0.2
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask4_914_18864",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 60,
    y: 64,
    width: 23,
    height: 23
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M66.8517 64.5403L60.5703 70.8191L76.2712 86.5137L82.5526 80.2349L66.8517 64.5403Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_914_18864)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M71.5627 53.2388L49.2668 75.5256L71.5627 97.8125L93.8585 75.5256L71.5627 53.2388Z",
    fill: "#32DCDC",
    fillOpacity: 0.2
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask5_914_18864",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 197,
    y: 41,
    width: 23,
    height: 22
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M213.529 41.0019L197.828 56.6965L204.11 62.9754L219.811 47.2807L213.529 41.0019Z",
    fill: "white"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask5_914_18864)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M208.818 29.7007L186.522 51.9875L208.818 74.2744L231.114 51.9875L208.818 29.7007Z",
    fill: "#32DCDC",
    fillOpacity: 0.2
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask6_914_18864",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 174,
    y: 64,
    width: 23,
    height: 23
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M189.977 64.5447L174.276 80.2393L180.557 86.5181L196.258 70.8235L189.977 64.5447Z",
    fill: "white"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask6_914_18864)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M185.268 53.2407L162.973 75.5276L185.269 97.8145L207.564 75.5276L185.268 53.2407Z",
    fill: "#32DCDC",
    fillOpacity: 0.2
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask7_914_18864",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 174,
    y: 40,
    width: 23,
    height: 23
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M180.558 40.9992L174.276 47.2781L189.977 62.9727L196.259 56.6938L180.558 40.9992Z",
    fill: "white"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask7_914_18864)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M185.269 29.6978L162.973 51.9846L185.269 74.2715L207.565 51.9846L185.269 29.6978Z",
    fill: "#32DCDC",
    fillOpacity: 0.2
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask8_914_18864",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 197,
    y: 64,
    width: 23,
    height: 23
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M204.11 64.5422L197.828 70.821L213.529 86.5156L219.811 80.2368L204.11 64.5422Z",
    fill: "white"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask8_914_18864)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M208.818 53.2397L186.522 75.5266L208.818 97.8135L231.114 75.5266L208.818 53.2397Z",
    fill: "#32DCDC",
    fillOpacity: 0.2
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask9_914_18864",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 335,
    y: 41,
    width: 23,
    height: 22
  }, _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M350.784 41.0005L335.083 56.6951L341.365 62.9739L357.066 47.2793L350.784 41.0005Z",
    fill: "white"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask9_914_18864)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M346.073 29.6992L323.777 51.9861L346.073 74.273L368.369 51.9861L346.073 29.6992Z",
    fill: "#32DCDC",
    fillOpacity: 0.2
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask10_914_18864",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 311,
    y: 64,
    width: 23,
    height: 23
  }, _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M327.232 64.543L311.531 80.2375L317.812 86.5164L333.513 70.8218L327.232 64.543Z",
    fill: "white"
  }))), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask10_914_18864)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M322.521 53.2415L300.225 75.5283L322.521 97.8152L344.817 75.5284L322.521 53.2415Z",
    fill: "#32DCDC",
    fillOpacity: 0.2
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask11_914_18864",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 311,
    y: 40,
    width: 23,
    height: 23
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M317.812 40.9978L311.531 47.2766L327.232 62.9712L333.513 56.6924L317.812 40.9978Z",
    fill: "white"
  }))), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask11_914_18864)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M322.521 29.6988L300.225 51.9856L322.521 74.2725L344.817 51.9856L322.521 29.6988Z",
    fill: "#32DCDC",
    fillOpacity: 0.2
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask12_914_18864",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 335,
    y: 64,
    width: 23,
    height: 23
  }, _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M341.362 64.5432L335.081 70.822L350.781 86.5166L357.063 80.2378L341.362 64.5432Z",
    fill: "white"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask12_914_18864)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M346.073 53.2417L323.777 75.5286L346.073 97.8154L368.369 75.5285L346.073 53.2417Z",
    fill: "#32DCDC",
    fillOpacity: 0.2
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask13_914_18864",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 472,
    y: 41,
    width: 23,
    height: 22
  }, _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M488.036 41.0012L472.335 56.6958L478.617 62.9746L494.318 47.28L488.036 41.0012Z",
    fill: "white"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask13_914_18864)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M483.331 29.6972L461.035 51.9841L483.331 74.271L505.627 51.9841L483.331 29.6972Z",
    fill: "#32DCDC",
    fillOpacity: 0.2
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask14_914_18864",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 448,
    y: 64,
    width: 23,
    height: 23
  }, _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M464.49 64.5415L448.789 80.2361L455.07 86.5149L470.771 70.8204L464.49 64.5415Z",
    fill: "white"
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask14_914_18864)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M459.779 53.24L437.483 75.5269L459.779 97.8137L482.075 75.5269L459.779 53.24Z",
    fill: "#32DCDC",
    fillOpacity: 0.2
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask15_914_18864",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 448,
    y: 40,
    width: 23,
    height: 23
  }, _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M455.064 40.9985L448.783 47.2773L464.484 62.9719L470.765 56.6931L455.064 40.9985Z",
    fill: "white"
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask15_914_18864)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M459.779 29.6971L437.483 51.9839L459.779 74.2708L482.075 51.9839L459.779 29.6971Z",
    fill: "#32DCDC",
    fillOpacity: 0.2
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask16_914_18864",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 472,
    y: 64,
    width: 23,
    height: 23
  }, _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M478.62 64.5415L472.339 70.8203L488.04 86.5149L494.321 80.2361L478.62 64.5415Z",
    fill: "white"
  }))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask16_914_18864)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M483.331 53.24L461.035 75.5269L483.331 97.8137L505.627 75.5268L483.331 53.24Z",
    fill: "#32DCDC",
    fillOpacity: 0.2
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask17_914_18864",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 609,
    y: 40,
    width: 23,
    height: 23
  }, _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M625.294 40.9997L609.594 56.6943L615.875 62.9732L631.576 47.2786L625.294 40.9997Z",
    fill: "white"
  }))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask17_914_18864)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M620.583 29.6982L598.288 51.9851L620.583 74.272L642.879 51.9851L620.583 29.6982Z",
    fill: "#32DCDC",
    fillOpacity: 0.2
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask18_914_18864",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 586,
    y: 64,
    width: 23,
    height: 23
  }, _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M601.742 64.5423L586.041 80.2368L592.323 86.5156L608.024 70.8211L601.742 64.5423Z",
    fill: "white"
  }))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask18_914_18864)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M597.031 53.2408L574.735 75.5276L597.031 97.8145L619.327 75.5276L597.031 53.2408Z",
    fill: "#32DCDC",
    fillOpacity: 0.2
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask19_914_18864",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 586,
    y: 40,
    width: 23,
    height: 23
  }, _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M592.323 40.997L586.041 47.2759L601.742 62.9705L608.024 56.6916L592.323 40.997Z",
    fill: "white"
  }))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask19_914_18864)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M597.031 29.6983L574.735 51.9851L597.031 74.272L619.327 51.9851L597.031 29.6983Z",
    fill: "#32DCDC",
    fillOpacity: 0.2
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask20_914_18864",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 609,
    y: 64,
    width: 23,
    height: 23
  }, _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M615.875 64.54L609.593 70.8188L625.294 86.5134L631.576 80.2346L615.875 64.54Z",
    fill: "white"
  }))), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask20_914_18864)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M620.583 53.2409L598.287 75.5278L620.583 97.8147L642.879 75.5278L620.583 53.2409Z",
    fill: "#32DCDC",
    fillOpacity: 0.2
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask21_914_18864",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 60,
    y: 169,
    width: 23,
    height: 23
  }, _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M76.2739 169.376L60.573 185.07L66.8544 191.349L82.5553 175.655L76.2739 169.376Z",
    fill: "white"
  }))), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask21_914_18864)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M71.5627 158.074L49.2668 180.361L71.5627 202.648L93.8585 180.361L71.5627 158.074Z",
    fill: "#32DCDC",
    fillOpacity: 0.2
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask22_914_18864",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 37,
    y: 192,
    width: 23,
    height: 23
  }, _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M52.7224 192.916L37.0215 208.61L43.3029 214.889L59.0038 199.195L52.7224 192.916Z",
    fill: "white"
  }))), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask22_914_18864)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M48.0139 181.617L25.718 203.904L48.0139 226.191L70.3097 203.904L48.0139 181.617Z",
    fill: "#32DCDC",
    fillOpacity: 0.2
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask23_914_18864",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 37,
    y: 169,
    width: 23,
    height: 23
  }, _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M43.3021 169.373L37.0208 175.652L52.7217 191.346L59.003 185.068L43.3021 169.373Z",
    fill: "white"
  }))), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask23_914_18864)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M48.0107 158.074L25.7148 180.361L48.0107 202.648L70.3065 180.361L48.0107 158.074Z",
    fill: "#32DCDC",
    fillOpacity: 0.2
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask24_914_18864",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 60,
    y: 192,
    width: 23,
    height: 23
  }, _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M66.8551 192.918L60.5737 199.197L76.2746 214.892L82.556 208.613L66.8551 192.918Z",
    fill: "white"
  }))), _g22 || (_g22 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask24_914_18864)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M71.5661 181.617L49.2703 203.904L71.5661 226.191L93.862 203.904L71.5661 181.617Z",
    fill: "#32DCDC",
    fillOpacity: 0.2
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask25_914_18864",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 197,
    y: 169,
    width: 23,
    height: 23
  }, _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M213.53 169.376L197.829 185.071L204.11 191.35L219.811 175.655L213.53 169.376Z",
    fill: "white"
  }))), _g23 || (_g23 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask25_914_18864)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M208.819 158.075L186.523 180.362L208.819 202.649L231.114 180.362L208.819 158.075Z",
    fill: "#32DCDC",
    fillOpacity: 0.2
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask26_914_18864",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 174,
    y: 192,
    width: 23,
    height: 23
  }, _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M189.975 192.92L174.274 208.615L180.555 214.894L196.256 199.199L189.975 192.92Z",
    fill: "white"
  }))), _g24 || (_g24 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask26_914_18864)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M185.268 181.619L162.973 203.906L185.269 226.192L207.564 203.906L185.268 181.619Z",
    fill: "#32DCDC",
    fillOpacity: 0.2
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask27_914_18864",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 174,
    y: 169,
    width: 23,
    height: 23
  }, _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M180.558 169.377L174.276 175.656L189.977 191.351L196.259 185.072L180.558 169.377Z",
    fill: "white"
  }))), _g25 || (_g25 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask27_914_18864)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M185.269 158.076L162.973 180.363L185.269 202.65L207.565 180.363L185.269 158.076Z",
    fill: "#32DCDC",
    fillOpacity: 0.2
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask28_914_18864",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 197,
    y: 192,
    width: 23,
    height: 23
  }, _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M204.11 192.917L197.828 199.196L213.529 214.89L219.811 208.611L204.11 192.917Z",
    fill: "white"
  }))), _g26 || (_g26 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask28_914_18864)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M208.818 181.618L186.522 203.905L208.818 226.192L231.114 203.905L208.818 181.618Z",
    fill: "#32DCDC",
    fillOpacity: 0.2
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask29_914_18864",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 335,
    y: 169,
    width: 23,
    height: 23
  }, _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M350.784 169.378L335.083 185.073L341.365 191.352L357.066 175.657L350.784 169.378Z",
    fill: "white"
  }))), _g27 || (_g27 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask29_914_18864)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M346.073 158.077L323.777 180.364L346.073 202.651L368.369 180.364L346.073 158.077Z",
    fill: "#32DCDC",
    fillOpacity: 0.2
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask30_914_18864",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 311,
    y: 192,
    width: 23,
    height: 23
  }, _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M327.233 192.918L311.532 208.613L317.813 214.892L333.514 199.197L327.233 192.918Z",
    fill: "white"
  }))), _g28 || (_g28 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask30_914_18864)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M322.524 181.62L300.228 203.906L322.524 226.193L344.82 203.907L322.524 181.62Z",
    fill: "#32DCDC",
    fillOpacity: 0.2
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask31_914_18864",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 311,
    y: 169,
    width: 23,
    height: 23
  }, _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M317.813 169.376L311.531 175.655L327.232 191.349L333.514 185.07L317.813 169.376Z",
    fill: "white"
  }))), _g29 || (_g29 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask31_914_18864)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M322.521 158.077L300.225 180.364L322.521 202.651L344.817 180.364L322.521 158.077Z",
    fill: "#32DCDC",
    fillOpacity: 0.2
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask32_914_18864",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 335,
    y: 192,
    width: 23,
    height: 23
  }, _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M341.365 192.921L335.084 199.2L350.785 214.895L357.066 208.616L341.365 192.921Z",
    fill: "white"
  }))), _g30 || (_g30 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask32_914_18864)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M346.077 181.62L323.781 203.906L346.077 226.193L368.372 203.906L346.077 181.62Z",
    fill: "#32DCDC",
    fillOpacity: 0.2
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask33_914_18864",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 472,
    y: 169,
    width: 23,
    height: 23
  }, _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M488.04 169.379L472.339 185.074L478.62 191.353L494.321 175.658L488.04 169.379Z",
    fill: "white"
  }))), _g31 || (_g31 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask33_914_18864)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M483.331 158.075L461.035 180.362L483.331 202.649L505.627 180.362L483.331 158.075Z",
    fill: "#32DCDC",
    fillOpacity: 0.2
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask34_914_18864",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 448,
    y: 192,
    width: 23,
    height: 23
  }, _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M464.488 192.917L448.787 208.612L455.068 214.89L470.769 199.196L464.488 192.917Z",
    fill: "white"
  }))), _g32 || (_g32 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask34_914_18864)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M459.779 181.618L437.483 203.905L459.779 226.192L482.075 203.905L459.779 181.618Z",
    fill: "#32DCDC",
    fillOpacity: 0.2
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask35_914_18864",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 448,
    y: 169,
    width: 23,
    height: 23
  }, _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M455.068 169.377L448.787 175.656L464.488 191.35L470.769 185.071L455.068 169.377Z",
    fill: "white"
  }))), _g33 || (_g33 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask35_914_18864)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M459.779 158.075L437.483 180.362L459.779 202.649L482.075 180.362L459.779 158.075Z",
    fill: "#32DCDC",
    fillOpacity: 0.2
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask36_914_18864",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 472,
    y: 192,
    width: 23,
    height: 23
  }, _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M478.62 192.92L472.339 199.198L488.04 214.893L494.321 208.614L478.62 192.92Z",
    fill: "white"
  }))), _g34 || (_g34 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask36_914_18864)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M483.331 181.618L461.035 203.905L483.331 226.192L505.627 203.905L483.331 181.618Z",
    fill: "#32DCDC",
    fillOpacity: 0.2
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask37_914_18864",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 609,
    y: 169,
    width: 23,
    height: 23
  }, _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M625.294 169.378L609.594 185.072L615.875 191.351L631.576 175.656L625.294 169.378Z",
    fill: "white"
  }))), _g35 || (_g35 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask37_914_18864)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M620.583 158.076L598.288 180.363L620.583 202.65L642.879 180.363L620.583 158.076Z",
    fill: "#32DCDC",
    fillOpacity: 0.2
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask38_914_18864",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 586,
    y: 192,
    width: 23,
    height: 23
  }, _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M601.74 192.918L586.039 208.613L592.32 214.891L608.021 199.197L601.74 192.918Z",
    fill: "white"
  }))), _g36 || (_g36 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask38_914_18864)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M597.031 181.619L574.735 203.906L597.031 226.193L619.327 203.906L597.031 181.619Z",
    fill: "#32DCDC",
    fillOpacity: 0.2
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask39_914_18864",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 586,
    y: 169,
    width: 23,
    height: 23
  }, _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M592.323 169.375L586.041 175.654L601.742 191.348L608.024 185.07L592.323 169.375Z",
    fill: "white"
  }))), _g37 || (_g37 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask39_914_18864)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M597.031 158.076L574.735 180.363L597.031 202.65L619.327 180.363L597.031 158.076Z",
    fill: "#32DCDC",
    fillOpacity: 0.2
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask40_914_18864",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 609,
    y: 192,
    width: 23,
    height: 23
  }, _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M615.875 192.918L609.594 199.197L625.294 214.891L631.576 208.613L615.875 192.918Z",
    fill: "white"
  }))), _g38 || (_g38 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask40_914_18864)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M620.583 181.619L598.288 203.906L620.583 226.193L642.879 203.906L620.583 181.619Z",
    fill: "#32DCDC",
    fillOpacity: 0.2
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask41_914_18864",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 60,
    y: 297,
    width: 23,
    height: 23
  }, _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M76.2749 297.751L60.574 313.446L66.8553 319.725L82.5562 304.03L76.2749 297.751Z",
    fill: "white"
  }))), _g39 || (_g39 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask41_914_18864)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M71.5664 286.452L49.2705 308.739L71.5664 331.026L93.8622 308.739L71.5664 286.452Z",
    fill: "#32DCDC",
    fillOpacity: 0.2
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask42_914_18864",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 37,
    y: 321,
    width: 23,
    height: 23
  }, _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M52.7226 321.294L37.0217 336.989L43.3031 343.267L59.004 327.573L52.7226 321.294Z",
    fill: "white"
  }))), _g40 || (_g40 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask42_914_18864)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M48.0114 309.993L25.7156 332.28L48.0114 354.566L70.3073 332.28L48.0114 309.993Z",
    fill: "#32DCDC",
    fillOpacity: 0.2
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask43_914_18864",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 37,
    y: 297,
    width: 23,
    height: 23
  }, _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M43.3031 297.749L37.0217 304.027L52.7227 319.722L59.004 313.443L43.3031 297.749Z",
    fill: "white"
  }))), _g41 || (_g41 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask43_914_18864)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M48.0141 286.452L25.7183 308.739L48.0141 331.026L70.31 308.739L48.0141 286.452Z",
    fill: "#32DCDC",
    fillOpacity: 0.2
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask44_914_18864",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 60,
    y: 321,
    width: 23,
    height: 23
  }, _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M66.8529 321.294L60.5715 327.573L76.2725 343.267L82.5538 336.989L66.8529 321.294Z",
    fill: "white"
  }))), _g42 || (_g42 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask44_914_18864)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M71.5639 309.993L49.2681 332.28L71.5639 354.566L93.8598 332.28L71.5639 309.993Z",
    fill: "#32DCDC",
    fillOpacity: 0.2
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask45_914_18864",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 197,
    y: 297,
    width: 23,
    height: 23
  }, _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M213.527 297.752L197.826 313.447L204.108 319.725L219.809 304.031L213.527 297.752Z",
    fill: "white"
  }))), _g43 || (_g43 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask45_914_18864)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M208.819 286.453L186.523 308.74L208.819 331.027L231.115 308.74L208.819 286.453Z",
    fill: "#32DCDC",
    fillOpacity: 0.2
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask46_914_18864",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 174,
    y: 321,
    width: 23,
    height: 23
  }, _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M189.975 321.295L174.274 336.989L180.555 343.268L196.256 327.573L189.975 321.295Z",
    fill: "white"
  }))), _g44 || (_g44 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask46_914_18864)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M185.266 309.991L162.97 332.278L185.266 354.564L207.562 332.278L185.266 309.991Z",
    fill: "#32DCDC",
    fillOpacity: 0.2
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask47_914_18864",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 174,
    y: 297,
    width: 23,
    height: 23
  }, _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M180.555 297.749L174.274 304.028L189.975 319.723L196.256 313.444L180.555 297.749Z",
    fill: "white"
  }))), _g45 || (_g45 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask47_914_18864)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M185.269 286.451L162.973 308.738L185.269 331.024L207.565 308.738L185.269 286.451Z",
    fill: "#32DCDC",
    fillOpacity: 0.2
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask48_914_18864",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 197,
    y: 321,
    width: 23,
    height: 23
  }, _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M204.107 321.292L197.826 327.571L213.527 343.266L219.808 336.987L204.107 321.292Z",
    fill: "white"
  }))), _g46 || (_g46 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask48_914_18864)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M208.816 309.994L186.52 332.281L208.816 354.567L231.112 332.281L208.816 309.994Z",
    fill: "#32DCDC",
    fillOpacity: 0.2
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask49_914_18864",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 335,
    y: 297,
    width: 23,
    height: 23
  }, _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M350.785 297.75L335.084 313.445L341.366 319.724L357.067 304.029L350.785 297.75Z",
    fill: "white"
  }))), _g47 || (_g47 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask49_914_18864)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M346.077 286.452L323.781 308.739L346.077 331.025L368.373 308.739L346.077 286.452Z",
    fill: "#32DCDC",
    fillOpacity: 0.2
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask50_914_18864",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 311,
    y: 321,
    width: 23,
    height: 23
  }, _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M327.233 321.297L311.532 336.991L317.814 343.27L333.514 327.575L327.233 321.297Z",
    fill: "white"
  }))), _g48 || (_g48 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask50_914_18864)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M322.522 309.995L300.226 332.282L322.522 354.569L344.818 332.282L322.522 309.995Z",
    fill: "#32DCDC",
    fillOpacity: 0.2
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask51_914_18864",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 311,
    y: 297,
    width: 23,
    height: 23
  }, _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M317.814 297.751L311.532 304.03L327.233 319.725L333.515 313.446L317.814 297.751Z",
    fill: "white"
  }))), _g49 || (_g49 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask51_914_18864)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M322.525 286.455L300.229 308.742L322.525 331.029L344.82 308.742L322.525 286.455Z",
    fill: "#32DCDC",
    fillOpacity: 0.2
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask52_914_18864",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 335,
    y: 321,
    width: 23,
    height: 23
  }, _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M341.363 321.293L335.082 327.572L350.783 343.267L357.064 336.988L341.363 321.293Z",
    fill: "white"
  }))), _g50 || (_g50 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask52_914_18864)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M346.074 309.992L323.778 332.279L346.074 354.565L368.37 332.279L346.074 309.992Z",
    fill: "#32DCDC",
    fillOpacity: 0.2
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask53_914_18864",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 472,
    y: 297,
    width: 23,
    height: 23
  }, _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M488.038 297.755L472.337 313.449L478.618 319.728L494.319 304.034L488.038 297.755Z",
    fill: "white"
  }))), _g51 || (_g51 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask53_914_18864)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M483.332 286.454L461.036 308.74L483.332 331.027L505.627 308.74L483.332 286.454Z",
    fill: "#32DCDC",
    fillOpacity: 0.2
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask54_914_18864",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 448,
    y: 321,
    width: 23,
    height: 23
  }, _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M464.488 321.295L448.787 336.99L455.068 343.268L470.769 327.574L464.488 321.295Z",
    fill: "white"
  }))), _g52 || (_g52 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask54_914_18864)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M459.777 309.993L437.481 332.28L459.777 354.567L482.073 332.28L459.777 309.993Z",
    fill: "#32DCDC",
    fillOpacity: 0.2
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask55_914_18864",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 448,
    y: 297,
    width: 23,
    height: 23
  }, _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M455.066 297.752L448.784 304.031L464.485 319.726L470.766 313.447L455.066 297.752Z",
    fill: "white"
  }))), _g53 || (_g53 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask55_914_18864)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M459.779 286.453L437.483 308.74L459.779 331.027L482.075 308.74L459.779 286.453Z",
    fill: "#32DCDC",
    fillOpacity: 0.2
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask56_914_18864",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 472,
    y: 321,
    width: 23,
    height: 23
  }, _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M478.618 321.295L472.336 327.574L488.037 343.269L494.319 336.99L478.618 321.295Z",
    fill: "white"
  }))), _g54 || (_g54 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask56_914_18864)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M483.329 309.994L461.033 332.281L483.329 354.567L505.625 332.281L483.329 309.994Z",
    fill: "#32DCDC",
    fillOpacity: 0.2
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask57_914_18864",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 609,
    y: 297,
    width: 23,
    height: 23
  }, _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M625.292 297.753L609.591 313.448L615.873 319.727L631.574 304.032L625.292 297.753Z",
    fill: "white"
  }))), _g55 || (_g55 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask57_914_18864)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M620.584 286.454L598.288 308.741L620.584 331.028L642.88 308.741L620.584 286.454Z",
    fill: "#32DCDC",
    fillOpacity: 0.2
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask58_914_18864",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 586,
    y: 321,
    width: 23,
    height: 23
  }, _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M601.743 321.296L586.042 336.99L592.324 343.269L608.024 327.575L601.743 321.296Z",
    fill: "white"
  }))), _g56 || (_g56 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask58_914_18864)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M597.032 309.995L574.736 332.281L597.032 354.568L619.328 332.282L597.032 309.995Z",
    fill: "#32DCDC",
    fillOpacity: 0.2
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask59_914_18864",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 586,
    y: 297,
    width: 23,
    height: 23
  }, _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M592.32 297.751L586.039 304.03L601.74 319.724L608.021 313.445L592.32 297.751Z",
    fill: "white"
  }))), _g57 || (_g57 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask59_914_18864)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M597.031 286.454L574.735 308.741L597.031 331.028L619.327 308.741L597.031 286.454Z",
    fill: "#32DCDC",
    fillOpacity: 0.2
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask60_914_18864",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 609,
    y: 321,
    width: 23,
    height: 23
  }, _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M615.876 321.294L609.594 327.573L625.295 343.267L631.577 336.988L615.876 321.294Z",
    fill: "white"
  }))), _g58 || (_g58 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask60_914_18864)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M620.584 309.995L598.289 332.281L620.584 354.568L642.88 332.281L620.584 309.995Z",
    fill: "#32DCDC",
    fillOpacity: 0.2
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask61_914_18864",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 60,
    y: 426,
    width: 23,
    height: 23
  }, _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M76.2751 426.129L60.5742 441.824L66.8556 448.103L82.5565 432.408L76.2751 426.129Z",
    fill: "white"
  }))), _g59 || (_g59 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask61_914_18864)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M71.5642 414.828L49.2683 437.115L71.5642 459.401L93.86 437.115L71.5642 414.828Z",
    fill: "#32DCDC",
    fillOpacity: 0.2
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask62_914_18864",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 37,
    y: 449,
    width: 23,
    height: 23
  }, _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M52.7202 449.669L37.0193 465.364L43.3006 471.643L59.0016 455.948L52.7202 449.669Z",
    fill: "white"
  }))), _g60 || (_g60 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask62_914_18864)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M48.0117 438.37L25.7158 460.657L48.0117 482.944L70.3075 460.657L48.0117 438.37Z",
    fill: "#32DCDC",
    fillOpacity: 0.2
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask63_914_18864",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 37,
    y: 426,
    width: 23,
    height: 23
  }, _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M43.3033 426.126L37.022 432.405L52.7229 448.1L59.0042 441.821L43.3033 426.126Z",
    fill: "white"
  }))), _g61 || (_g61 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask63_914_18864)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M48.0119 414.828L25.7161 437.115L48.0119 459.401L70.3078 437.115L48.0119 414.828Z",
    fill: "#32DCDC",
    fillOpacity: 0.2
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask64_914_18864",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 60,
    y: 449,
    width: 23,
    height: 23
  }, _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M66.8529 449.672L60.5715 455.951L76.2725 471.646L82.5538 465.367L66.8529 449.672Z",
    fill: "white"
  }))), _g62 || (_g62 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask64_914_18864)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M71.5639 438.371L49.2681 460.658L71.5639 482.945L93.8598 460.658L71.5639 438.371Z",
    fill: "#32DCDC",
    fillOpacity: 0.2
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask65_914_18864",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 197,
    y: 426,
    width: 23,
    height: 23
  }, _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M213.527 426.13L197.826 441.825L204.108 448.104L219.809 432.409L213.527 426.13Z",
    fill: "white"
  }))), _g63 || (_g63 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask65_914_18864)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M208.816 414.829L186.521 437.116L208.816 459.403L231.112 437.116L208.816 414.829Z",
    fill: "#32DCDC",
    fillOpacity: 0.2
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask66_914_18864",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 174,
    y: 449,
    width: 23,
    height: 23
  }, _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M189.976 449.67L174.275 465.365L180.556 471.644L196.257 455.949L189.976 449.67Z",
    fill: "white"
  }))), _g64 || (_g64 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask66_914_18864)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M185.27 438.369L162.974 460.656L185.27 482.943L207.566 460.656L185.27 438.369Z",
    fill: "#32DCDC",
    fillOpacity: 0.2
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask67_914_18864",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 174,
    y: 426,
    width: 23,
    height: 23
  }, _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M180.556 426.127L174.274 432.406L189.975 448.101L196.256 441.822L180.556 426.127Z",
    fill: "white"
  }))), _g65 || (_g65 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask67_914_18864)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M185.267 414.826L162.971 437.113L185.267 459.4L207.562 437.113L185.267 414.826Z",
    fill: "#32DCDC",
    fillOpacity: 0.2
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask68_914_18864",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 197,
    y: 449,
    width: 23,
    height: 23
  }, _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M204.111 449.67L197.83 455.949L213.531 471.644L219.812 465.365L204.111 449.67Z",
    fill: "white"
  }))), _g66 || (_g66 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask68_914_18864)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M208.82 438.372L186.524 460.658L208.82 482.945L231.115 460.658L208.82 438.372Z",
    fill: "#32DCDC",
    fillOpacity: 0.2
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask69_914_18864",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 335,
    y: 426,
    width: 23,
    height: 23
  }, _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M350.786 426.128L335.085 441.823L341.366 448.102L357.067 432.407L350.786 426.128Z",
    fill: "white"
  }))), _g67 || (_g67 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask69_914_18864)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M346.075 414.827L323.779 437.114L346.075 459.401L368.371 437.114L346.075 414.827Z",
    fill: "#32DCDC",
    fillOpacity: 0.2
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask70_914_18864",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 311,
    y: 449,
    width: 23,
    height: 23
  }, _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M327.231 449.669L311.53 465.363L317.811 471.642L333.512 455.948L327.231 449.669Z",
    fill: "white"
  }))), _g68 || (_g68 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask70_914_18864)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M322.522 438.373L300.226 460.66L322.522 482.947L344.818 460.66L322.522 438.373Z",
    fill: "#32DCDC",
    fillOpacity: 0.2
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask71_914_18864",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 311,
    y: 426,
    width: 23,
    height: 23
  }, _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M317.814 426.126L311.532 432.405L327.233 448.099L333.514 441.821L317.814 426.126Z",
    fill: "white"
  }))), _g69 || (_g69 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask71_914_18864)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M322.522 414.827L300.226 437.114L322.522 459.401L344.818 437.114L322.522 414.827Z",
    fill: "#32DCDC",
    fillOpacity: 0.2
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask72_914_18864",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 335,
    y: 449,
    width: 23,
    height: 23
  }, _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M341.363 449.672L335.082 455.95L350.783 471.645L357.064 465.366L341.363 449.672Z",
    fill: "white"
  }))), _g70 || (_g70 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask72_914_18864)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M346.074 438.37L323.778 460.657L346.074 482.944L368.37 460.657L346.074 438.37Z",
    fill: "#32DCDC",
    fillOpacity: 0.2
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask73_914_18864",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 472,
    y: 426,
    width: 23,
    height: 23
  }, _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M488.038 426.129L472.337 441.824L478.618 448.103L494.319 432.408L488.038 426.129Z",
    fill: "white"
  }))), _g71 || (_g71 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask73_914_18864)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M483.329 414.829L461.033 437.116L483.329 459.403L505.625 437.116L483.329 414.829Z",
    fill: "#32DCDC",
    fillOpacity: 0.2
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask74_914_18864",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 448,
    y: 449,
    width: 23,
    height: 23
  }, _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M464.489 449.671L448.788 465.365L455.069 471.644L470.77 455.95L464.489 449.671Z",
    fill: "white"
  }))), _g72 || (_g72 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask74_914_18864)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M459.78 438.372L437.484 460.659L459.78 482.946L482.076 460.659L459.78 438.372Z",
    fill: "#32DCDC",
    fillOpacity: 0.2
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask75_914_18864",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 448,
    y: 426,
    width: 23,
    height: 23
  }, _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M455.066 426.13L448.785 432.409L464.486 448.104L470.767 441.825L455.066 426.13Z",
    fill: "white"
  }))), _g73 || (_g73 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask75_914_18864)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M459.777 414.829L437.481 437.116L459.777 459.403L482.073 437.116L459.777 414.829Z",
    fill: "#32DCDC",
    fillOpacity: 0.2
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask76_914_18864",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 472,
    y: 449,
    width: 23,
    height: 23
  }, _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M478.621 449.67L472.34 455.948L488.041 471.643L494.322 465.364L478.621 449.67Z",
    fill: "white"
  }))), _g74 || (_g74 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask76_914_18864)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M483.332 438.368L461.037 460.655L483.332 482.942L505.628 460.655L483.332 438.368Z",
    fill: "#32DCDC",
    fillOpacity: 0.2
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask77_914_18864",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 609,
    y: 426,
    width: 23,
    height: 23
  }, _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M625.296 426.131L609.595 441.826L615.876 448.105L631.577 432.41L625.296 426.131Z",
    fill: "white"
  }))), _g75 || (_g75 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask77_914_18864)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M620.585 414.83L598.289 437.117L620.585 459.404L642.881 437.117L620.585 414.83Z",
    fill: "#32DCDC",
    fillOpacity: 0.2
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask78_914_18864",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 586,
    y: 449,
    width: 23,
    height: 23
  }, _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M601.741 449.671L586.04 465.366L592.321 471.645L608.022 455.95L601.741 449.671Z",
    fill: "white"
  }))), _g76 || (_g76 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask78_914_18864)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M597.032 438.372L574.736 460.659L597.032 482.946L619.328 460.659L597.032 438.372Z",
    fill: "#32DCDC",
    fillOpacity: 0.2
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask79_914_18864",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 586,
    y: 426,
    width: 23,
    height: 23
  }, _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M592.324 426.129L586.042 432.407L601.743 448.102L608.025 441.823L592.324 426.129Z",
    fill: "white"
  }))), _g77 || (_g77 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask79_914_18864)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M597.032 414.83L574.737 437.117L597.032 459.404L619.328 437.117L597.032 414.83Z",
    fill: "#32DCDC",
    fillOpacity: 0.2
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask80_914_18864",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 609,
    y: 449,
    width: 23,
    height: 23
  }, _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M615.876 449.672L609.595 455.95L625.296 471.645L631.577 465.366L615.876 449.672Z",
    fill: "white"
  }))), _g78 || (_g78 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask80_914_18864)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M620.585 438.373L598.289 460.66L620.585 482.947L642.881 460.66L620.585 438.373Z",
    fill: "#32DCDC",
    fillOpacity: 0.2
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask81_914_18864",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 60,
    y: 554,
    width: 23,
    height: 23
  }, _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M76.2727 554.505L60.5718 570.199L66.8531 576.478L82.554 560.783L76.2727 554.505Z",
    fill: "white"
  }))), _g79 || (_g79 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask81_914_18864)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M71.5642 543.206L49.2683 565.493L71.5642 587.78L93.86 565.493L71.5642 543.206Z",
    fill: "#32DCDC",
    fillOpacity: 0.2
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask82_914_18864",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 37,
    y: 578,
    width: 23,
    height: 23
  }, _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M52.7239 578.048L37.0229 593.742L43.3043 600.021L59.0052 584.326L52.7239 578.048Z",
    fill: "white"
  }))), _g80 || (_g80 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask82_914_18864)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M48.0126 566.746L25.7168 589.033L48.0127 611.32L70.3085 589.033L48.0126 566.746Z",
    fill: "#32DCDC",
    fillOpacity: 0.2
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask83_914_18864",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 37,
    y: 554,
    width: 23,
    height: 23
  }, _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M43.3036 554.505L37.0222 560.784L52.7231 576.478L59.0045 570.199L43.3036 554.505Z",
    fill: "white"
  }))), _g81 || (_g81 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask83_914_18864)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M48.0122 543.206L25.7163 565.493L48.0122 587.78L70.308 565.493L48.0122 543.206Z",
    fill: "#32DCDC",
    fillOpacity: 0.2
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask84_914_18864",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 60,
    y: 578,
    width: 23,
    height: 23
  }, _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M66.8507 578.048L60.5693 584.326L76.2703 600.021L82.5516 593.742L66.8507 578.048Z",
    fill: "white"
  }))), _g82 || (_g82 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask84_914_18864)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M71.5615 566.746L49.2656 589.033L71.5615 611.32L93.8573 589.033L71.5615 566.746Z",
    fill: "#32DCDC",
    fillOpacity: 0.2
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask85_914_18864",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 197,
    y: 554,
    width: 23,
    height: 23
  }, _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M213.528 554.506L197.827 570.2L204.109 576.479L219.81 560.784L213.528 554.506Z",
    fill: "white"
  }))), _g83 || (_g83 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask85_914_18864)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M208.82 543.207L186.524 565.494L208.82 587.781L231.116 565.494L208.82 543.207Z",
    fill: "#32DCDC",
    fillOpacity: 0.2
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask86_914_18864",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 174,
    y: 578,
    width: 23,
    height: 23
  }, _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M189.976 578.048L174.275 593.743L180.557 600.022L196.257 584.327L189.976 578.048Z",
    fill: "white"
  }))), _g84 || (_g84 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask86_914_18864)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M185.268 566.744L162.972 589.031L185.268 611.318L207.563 589.031L185.268 566.744Z",
    fill: "#32DCDC",
    fillOpacity: 0.2
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask87_914_18864",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 174,
    y: 554,
    width: 23,
    height: 23
  }, _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M180.559 554.506L174.278 560.784L189.979 576.479L196.26 570.2L180.559 554.506Z",
    fill: "white"
  }))), _g85 || (_g85 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask87_914_18864)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M185.27 543.204L162.974 565.491L185.27 587.778L207.566 565.491L185.27 543.204Z",
    fill: "#32DCDC",
    fillOpacity: 0.2
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask88_914_18864",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 197,
    y: 578,
    width: 23,
    height: 23
  }, _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M204.109 578.046L197.827 584.325L213.528 600.019L219.81 593.74L204.109 578.046Z",
    fill: "white"
  }))), _g86 || (_g86 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask88_914_18864)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M208.817 566.747L186.521 589.034L208.817 611.321L231.113 589.034L208.817 566.747Z",
    fill: "#32DCDC",
    fillOpacity: 0.2
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask89_914_18864",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 335,
    y: 554,
    width: 23,
    height: 23
  }, _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M350.783 554.504L335.082 570.199L341.364 576.478L357.065 560.783L350.783 554.504Z",
    fill: "white"
  }))), _g87 || (_g87 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask89_914_18864)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M346.075 543.205L323.779 565.492L346.075 587.779L368.371 565.492L346.075 543.205Z",
    fill: "#32DCDC",
    fillOpacity: 0.2
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask90_914_18864",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 311,
    y: 578,
    width: 23,
    height: 23
  }, _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M327.231 578.047L311.53 593.741L317.811 600.02L333.512 584.326L327.231 578.047Z",
    fill: "white"
  }))), _g88 || (_g88 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask90_914_18864)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M322.52 566.745L300.224 589.032L322.52 611.319L344.816 589.032L322.52 566.745Z",
    fill: "#32DCDC",
    fillOpacity: 0.2
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask91_914_18864",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 311,
    y: 554,
    width: 23,
    height: 23
  }, _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M317.814 554.504L311.532 560.783L327.233 576.477L333.515 570.198L317.814 554.504Z",
    fill: "white"
  }))), _g89 || (_g89 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask91_914_18864)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M322.522 543.205L300.227 565.492L322.522 587.779L344.818 565.492L322.522 543.205Z",
    fill: "#32DCDC",
    fillOpacity: 0.2
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask92_914_18864",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 335,
    y: 578,
    width: 23,
    height: 23
  }, _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M341.361 578.047L335.079 584.326L350.78 600.02L357.062 593.741L341.361 578.047Z",
    fill: "white"
  }))), _g90 || (_g90 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask92_914_18864)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M346.072 566.745L323.776 589.032L346.072 611.319L368.368 589.032L346.072 566.745Z",
    fill: "#32DCDC",
    fillOpacity: 0.2
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask93_914_18864",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 472,
    y: 554,
    width: 23,
    height: 23
  }, _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M488.039 554.505L472.338 570.199L478.619 576.478L494.32 560.784L488.039 554.505Z",
    fill: "white"
  }))), _g91 || (_g91 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask93_914_18864)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M483.333 543.203L461.037 565.49L483.333 587.777L505.629 565.49L483.333 543.203Z",
    fill: "#32DCDC",
    fillOpacity: 0.2
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask94_914_18864",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 448,
    y: 578,
    width: 23,
    height: 23
  }, _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M464.489 578.045L448.788 593.74L455.069 600.019L470.77 584.324L464.489 578.045Z",
    fill: "white"
  }))), _g92 || (_g92 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask94_914_18864)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M459.778 566.747L437.482 589.034L459.778 611.321L482.074 589.034L459.778 566.747Z",
    fill: "#32DCDC",
    fillOpacity: 0.2
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask95_914_18864",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 448,
    y: 554,
    width: 23,
    height: 23
  }, _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M455.069 554.505L448.788 560.784L464.489 576.478L470.77 570.199L455.069 554.505Z",
    fill: "white"
  }))), _g93 || (_g93 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask95_914_18864)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M459.78 543.207L437.485 565.494L459.78 587.781L482.076 565.494L459.78 543.207Z",
    fill: "#32DCDC",
    fillOpacity: 0.2
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask96_914_18864",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 472,
    y: 578,
    width: 23,
    height: 23
  }, _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M478.619 578.045L472.338 584.324L488.039 600.019L494.32 593.74L478.619 578.045Z",
    fill: "white"
  }))), _g94 || (_g94 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask96_914_18864)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M483.33 566.744L461.034 589.031L483.33 611.318L505.626 589.031L483.33 566.744Z",
    fill: "#32DCDC",
    fillOpacity: 0.2
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask97_914_18864",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 609,
    y: 554,
    width: 23,
    height: 23
  }, _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M625.293 554.503L609.593 570.198L615.874 576.477L631.575 560.782L625.293 554.503Z",
    fill: "white"
  }))), _g95 || (_g95 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask97_914_18864)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M620.585 543.208L598.289 565.495L620.585 587.782L642.881 565.495L620.585 543.208Z",
    fill: "#32DCDC",
    fillOpacity: 0.2
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask98_914_18864",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 586,
    y: 578,
    width: 23,
    height: 23
  }, _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M601.741 578.05L586.04 593.744L592.321 600.023L608.022 584.328L601.741 578.05Z",
    fill: "white"
  }))), _g96 || (_g96 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask98_914_18864)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M597.03 566.748L574.734 589.035L597.03 611.322L619.326 589.035L597.03 566.748Z",
    fill: "#32DCDC",
    fillOpacity: 0.2
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask99_914_18864",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 586,
    y: 554,
    width: 23,
    height: 23
  }, _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M592.324 554.507L586.042 560.785L601.743 576.48L608.025 570.201L592.324 554.507Z",
    fill: "white"
  }))), _g97 || (_g97 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask99_914_18864)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M597.033 543.208L574.737 565.495L597.033 587.781L619.328 565.495L597.033 543.208Z",
    fill: "#32DCDC",
    fillOpacity: 0.2
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask100_914_18864",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 609,
    y: 578,
    width: 23,
    height: 23
  }, _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M615.874 578.047L609.592 584.326L625.293 600.021L631.575 593.742L615.874 578.047Z",
    fill: "white"
  }))), _g98 || (_g98 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask100_914_18864)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M620.582 566.745L598.286 589.031L620.582 611.318L642.878 589.031L620.582 566.745Z",
    fill: "#32DCDC",
    fillOpacity: 0.2
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask101_914_18864",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 60,
    y: 682,
    width: 23,
    height: 23
  }, _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M76.2766 682.883L60.5757 698.577L66.857 704.856L82.558 689.162L76.2766 682.883Z",
    fill: "white"
  }))), _g99 || (_g99 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask101_914_18864)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M71.5654 671.582L49.2695 693.868L71.5654 716.155L93.8612 693.868L71.5654 671.582Z",
    fill: "#32DCDC",
    fillOpacity: 0.2
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask102_914_18864",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 37,
    y: 706,
    width: 23,
    height: 23
  }, _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M52.7239 706.426L37.0229 722.12L43.3043 728.399L59.0052 712.704L52.7239 706.426Z",
    fill: "white"
  }))), _g100 || (_g100 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask102_914_18864)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M48.0129 695.124L25.717 717.411L48.0129 739.698L70.3087 717.411L48.0129 695.124Z",
    fill: "#32DCDC",
    fillOpacity: 0.2
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask103_914_18864",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 37,
    y: 682,
    width: 23,
    height: 23
  }, _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M43.3046 682.88L37.0232 689.159L52.7241 704.854L59.0055 698.575L43.3046 682.88Z",
    fill: "white"
  }))), _g101 || (_g101 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask103_914_18864)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M48.0131 671.581L25.7173 693.868L48.0132 716.155L70.309 693.868L48.0131 671.581Z",
    fill: "#32DCDC",
    fillOpacity: 0.2
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask104_914_18864",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 60,
    y: 706,
    width: 23,
    height: 23
  }, _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M66.8544 706.426L60.573 712.705L76.2739 728.399L82.5553 722.12L66.8544 706.426Z",
    fill: "white"
  }))), _g102 || (_g102 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask104_914_18864)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M71.5654 695.124L49.2695 717.411L71.5654 739.698L93.8612 717.411L71.5654 695.124Z",
    fill: "#32DCDC",
    fillOpacity: 0.2
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask105_914_18864",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 197,
    y: 682,
    width: 23,
    height: 23
  }, _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M213.529 682.884L197.828 698.578L204.109 704.857L219.81 689.163L213.529 682.884Z",
    fill: "white"
  }))), _g103 || (_g103 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask105_914_18864)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M208.818 671.582L186.522 693.869L208.818 716.156L231.113 693.869L208.818 671.582Z",
    fill: "#32DCDC",
    fillOpacity: 0.2
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask106_914_18864",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 174,
    y: 706,
    width: 23,
    height: 23
  }, _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M189.976 706.426L174.275 722.121L180.557 728.4L196.257 712.705L189.976 706.426Z",
    fill: "white"
  }))), _g104 || (_g104 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask106_914_18864)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M185.268 695.123L162.972 717.409L185.268 739.696L207.563 717.409L185.268 695.123Z",
    fill: "#32DCDC",
    fillOpacity: 0.2
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask107_914_18864",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 174,
    y: 682,
    width: 23,
    height: 23
  }, _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M180.557 682.881L174.275 689.16L189.976 704.855L196.258 698.576L180.557 682.881Z",
    fill: "white"
  }))), _g105 || (_g105 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask107_914_18864)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M185.268 671.58L162.972 693.867L185.268 716.154L207.564 693.867L185.268 671.58Z",
    fill: "#32DCDC",
    fillOpacity: 0.2
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask108_914_18864",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 197,
    y: 706,
    width: 23,
    height: 23
  }, _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M204.109 706.424L197.827 712.703L213.528 728.397L219.81 722.119L204.109 706.424Z",
    fill: "white"
  }))), _g106 || (_g106 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask108_914_18864)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M208.817 695.125L186.521 717.412L208.817 739.699L231.113 717.412L208.817 695.125Z",
    fill: "#32DCDC",
    fillOpacity: 0.2
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask109_914_18864",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 335,
    y: 682,
    width: 23,
    height: 23
  }, _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M350.783 682.882L335.082 698.577L341.364 704.855L357.065 689.161L350.783 682.882Z",
    fill: "white"
  }))), _g107 || (_g107 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask109_914_18864)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M346.072 671.581L323.776 693.868L346.072 716.155L368.368 693.868L346.072 671.581Z",
    fill: "#32DCDC",
    fillOpacity: 0.2
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask110_914_18864",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 311,
    y: 706,
    width: 23,
    height: 23
  }, _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M327.234 706.425L311.533 722.119L317.815 728.398L333.516 712.704L327.234 706.425Z",
    fill: "white"
  }))), _g108 || (_g108 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask110_914_18864)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M322.523 695.123L300.228 717.41L322.523 739.697L344.819 717.41L322.523 695.123Z",
    fill: "#32DCDC",
    fillOpacity: 0.2
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask111_914_18864",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 311,
    y: 682,
    width: 23,
    height: 23
  }, _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M317.811 682.879L311.53 689.158L327.231 704.853L333.512 698.574L317.811 682.879Z",
    fill: "white"
  }))), _g109 || (_g109 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask111_914_18864)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M322.52 671.581L300.224 693.867L322.52 716.154L344.816 693.867L322.52 671.581Z",
    fill: "#32DCDC",
    fillOpacity: 0.2
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask112_914_18864",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 335,
    y: 706,
    width: 23,
    height: 23
  }, _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M341.365 706.425L335.083 712.704L350.784 728.398L357.066 722.12L341.365 706.425Z",
    fill: "white"
  }))), _g110 || (_g110 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask112_914_18864)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M346.076 695.124L323.78 717.41L346.076 739.697L368.372 717.41L346.076 695.124Z",
    fill: "#32DCDC",
    fillOpacity: 0.2
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask113_914_18864",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 472,
    y: 682,
    width: 23,
    height: 23
  }, _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M488.039 682.883L472.338 698.578L478.619 704.856L494.32 689.162L488.039 682.883Z",
    fill: "white"
  }))), _g111 || (_g111 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask113_914_18864)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M483.33 671.579L461.034 693.866L483.33 716.153L505.626 693.866L483.33 671.579Z",
    fill: "#32DCDC",
    fillOpacity: 0.2
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask114_914_18864",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 448,
    y: 706,
    width: 23,
    height: 23
  }, _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M464.489 706.423L448.788 722.118L455.069 728.397L470.77 712.702L464.489 706.423Z",
    fill: "white"
  }))), _g112 || (_g112 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask114_914_18864)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M459.778 695.122L437.482 717.409L459.778 739.696L482.074 717.409L459.778 695.122Z",
    fill: "#32DCDC",
    fillOpacity: 0.2
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask115_914_18864",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 448,
    y: 682,
    width: 23,
    height: 23
  }, _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M455.067 682.88L448.786 689.159L464.487 704.854L470.768 698.575L455.067 682.88Z",
    fill: "white"
  }))), _g113 || (_g113 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask115_914_18864)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M459.778 671.579L437.482 693.866L459.778 716.153L482.074 693.866L459.778 671.579Z",
    fill: "#32DCDC",
    fillOpacity: 0.2
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask116_914_18864",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 472,
    y: 706,
    width: 23,
    height: 23
  }, _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M478.619 706.423L472.338 712.702L488.039 728.397L494.32 722.118L478.619 706.423Z",
    fill: "white"
  }))), _g114 || (_g114 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask116_914_18864)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M483.33 695.122L461.034 717.409L483.33 739.696L505.626 717.409L483.33 695.122Z",
    fill: "#32DCDC",
    fillOpacity: 0.2
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask117_914_18864",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 609,
    y: 682,
    width: 23,
    height: 23
  }, _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M625.293 682.881L609.593 698.576L615.874 704.855L631.575 689.16L625.293 682.881Z",
    fill: "white"
  }))), _g115 || (_g115 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask117_914_18864)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M620.582 671.58L598.287 693.867L620.582 716.154L642.878 693.867L620.582 671.58Z",
    fill: "#32DCDC",
    fillOpacity: 0.2
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask118_914_18864",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 586,
    y: 706,
    width: 23,
    height: 23
  }, _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M601.745 706.424L586.044 722.119L592.325 728.397L608.026 712.703L601.745 706.424Z",
    fill: "white"
  }))), _g116 || (_g116 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask118_914_18864)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M597.034 695.126L574.738 717.413L597.034 739.7L619.329 717.413L597.034 695.126Z",
    fill: "#32DCDC",
    fillOpacity: 0.2
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask119_914_18864",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 586,
    y: 682,
    width: 23,
    height: 23
  }, _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M592.322 682.882L586.041 689.161L601.741 704.856L608.023 698.577L592.322 682.882Z",
    fill: "white"
  }))), _g117 || (_g117 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask119_914_18864)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M597.03 671.584L574.735 693.87L597.03 716.157L619.326 693.87L597.03 671.584Z",
    fill: "#32DCDC",
    fillOpacity: 0.2
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask120_914_18864",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 609,
    y: 706,
    width: 23,
    height: 23
  }, _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M615.874 706.422L609.592 712.701L625.293 728.395L631.575 722.116L615.874 706.422Z",
    fill: "white"
  }))), _g118 || (_g118 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask120_914_18864)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M620.582 695.123L598.287 717.41L620.582 739.697L642.878 717.41L620.582 695.123Z",
    fill: "#32DCDC",
    fillOpacity: 0.2
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask121_914_18864",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 60,
    y: 811,
    width: 23,
    height: 23
  }, _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M76.2739 811.255L60.573 826.949L66.8544 833.228L82.5553 817.534L76.2739 811.255Z",
    fill: "white"
  }))), _g119 || (_g119 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask121_914_18864)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M71.5654 799.956L49.2695 822.243L71.5653 844.53L93.8612 822.243L71.5654 799.956Z",
    fill: "#32DCDC",
    fillOpacity: 0.2
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask122_914_18864",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 37,
    y: 834,
    width: 23,
    height: 23
  }, _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M52.7217 834.801L37.0208 850.496L43.3021 856.774L59.003 841.08L52.7217 834.801Z",
    fill: "white"
  }))), _g120 || (_g120 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask122_914_18864)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M48.0131 823.502L25.7173 845.789L48.0131 868.076L70.3089 845.789L48.0131 823.502Z",
    fill: "#32DCDC",
    fillOpacity: 0.2
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask123_914_18864",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 37,
    y: 811,
    width: 23,
    height: 23
  }, _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M43.3048 811.258L37.0234 817.537L52.7243 833.232L59.0057 826.953L43.3048 811.258Z",
    fill: "white"
  }))), _g121 || (_g121 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask123_914_18864)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M48.0134 799.959L25.7175 822.246L48.0133 844.533L70.3092 822.246L48.0134 799.959Z",
    fill: "#32DCDC",
    fillOpacity: 0.2
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask124_914_18864",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 60,
    y: 834,
    width: 23,
    height: 23
  }, _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M66.8544 834.8L60.573 841.079L76.2739 856.774L82.5552 850.495L66.8544 834.8Z",
    fill: "white"
  }))), _g122 || (_g122 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask124_914_18864)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M71.5654 823.499L49.2695 845.786L71.5653 868.073L93.8612 845.786L71.5654 823.499Z",
    fill: "#32DCDC",
    fillOpacity: 0.2
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask125_914_18864",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 197,
    y: 811,
    width: 23,
    height: 23
  }, _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M213.526 811.259L197.825 826.954L204.107 833.233L219.807 817.538L213.526 811.259Z",
    fill: "white"
  }))), _g123 || (_g123 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask125_914_18864)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M208.818 799.96L186.522 822.247L208.818 844.534L231.113 822.247L208.818 799.96Z",
    fill: "#32DCDC",
    fillOpacity: 0.2
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask126_914_18864",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 174,
    y: 834,
    width: 23,
    height: 23
  }, _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M189.974 834.802L174.273 850.497L180.554 856.775L196.255 841.081L189.974 834.802Z",
    fill: "white"
  }))), _g124 || (_g124 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask126_914_18864)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M185.268 823.501L162.972 845.788L185.267 868.074L207.563 845.788L185.268 823.501Z",
    fill: "#32DCDC",
    fillOpacity: 0.2
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask127_914_18864",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 174,
    y: 811,
    width: 23,
    height: 23
  }, _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M180.557 811.259L174.276 817.538L189.977 833.233L196.258 826.954L180.557 811.259Z",
    fill: "white"
  }))), _g125 || (_g125 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask127_914_18864)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M185.268 799.958L162.972 822.245L185.268 844.531L207.564 822.245L185.268 799.958Z",
    fill: "#32DCDC",
    fillOpacity: 0.2
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask128_914_18864",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 197,
    y: 834,
    width: 23,
    height: 23
  }, _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M204.109 834.802L197.828 841.081L213.529 856.776L219.81 850.497L204.109 834.802Z",
    fill: "white"
  }))), _g126 || (_g126 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask128_914_18864)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M208.818 823.503L186.522 845.79L208.818 868.077L231.113 845.79L208.818 823.503Z",
    fill: "#32DCDC",
    fillOpacity: 0.2
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask129_914_18864",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 335,
    y: 811,
    width: 23,
    height: 23
  }, _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M350.784 811.258L335.083 826.952L341.365 833.231L357.066 817.537L350.784 811.258Z",
    fill: "white"
  }))), _g127 || (_g127 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask129_914_18864)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M346.076 799.959L323.78 822.246L346.076 844.533L368.372 822.246L346.076 799.959Z",
    fill: "#32DCDC",
    fillOpacity: 0.2
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask130_914_18864",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 311,
    y: 834,
    width: 23,
    height: 23
  }, _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M327.232 834.8L311.531 850.495L317.813 856.774L333.513 841.079L327.232 834.8Z",
    fill: "white"
  }))), _g128 || (_g128 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask130_914_18864)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M322.523 823.501L300.228 845.788L322.523 868.075L344.819 845.788L322.523 823.501Z",
    fill: "#32DCDC",
    fillOpacity: 0.2
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask131_914_18864",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 311,
    y: 811,
    width: 23,
    height: 23
  }, _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M317.815 811.258L311.534 817.536L327.235 833.231L333.516 826.952L317.815 811.258Z",
    fill: "white"
  }))), _g129 || (_g129 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask131_914_18864)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M322.523 799.959L300.228 822.246L322.523 844.532L344.819 822.246L322.523 799.959Z",
    fill: "#32DCDC",
    fillOpacity: 0.2
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask132_914_18864",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 335,
    y: 834,
    width: 23,
    height: 23
  }, _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M341.365 834.803L335.083 841.082L350.784 856.777L357.065 850.498L341.365 834.803Z",
    fill: "white"
  }))), _g130 || (_g130 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask132_914_18864)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M346.076 823.502L323.78 845.789L346.076 868.075L368.371 845.789L346.076 823.502Z",
    fill: "#32DCDC",
    fillOpacity: 0.2
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask133_914_18864",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 472,
    y: 811,
    width: 23,
    height: 23
  }, _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M488.037 811.259L472.336 826.953L478.617 833.232L494.318 817.537L488.037 811.259Z",
    fill: "white"
  }))), _g131 || (_g131 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask133_914_18864)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M483.331 799.957L461.035 822.244L483.331 844.531L505.627 822.244L483.331 799.957Z",
    fill: "#32DCDC",
    fillOpacity: 0.2
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask134_914_18864",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 448,
    y: 834,
    width: 23,
    height: 23
  }, _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M464.487 834.799L448.786 850.493L455.067 856.772L470.768 841.078L464.487 834.799Z",
    fill: "white"
  }))), _g132 || (_g132 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask134_914_18864)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M459.778 823.5L437.482 845.787L459.778 868.074L482.074 845.787L459.778 823.5Z",
    fill: "#32DCDC",
    fillOpacity: 0.2
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask135_914_18864",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 448,
    y: 811,
    width: 23,
    height: 23
  }, _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M455.067 811.258L448.786 817.537L464.487 833.232L470.768 826.953L455.067 811.258Z",
    fill: "white"
  }))), _g133 || (_g133 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask135_914_18864)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M459.778 799.957L437.482 822.244L459.778 844.53L482.074 822.244L459.778 799.957Z",
    fill: "#32DCDC",
    fillOpacity: 0.2
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask136_914_18864",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 472,
    y: 834,
    width: 23,
    height: 23
  }, _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M478.619 834.801L472.338 841.08L488.039 856.775L494.32 850.496L478.619 834.801Z",
    fill: "white"
  }))), _g134 || (_g134 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask136_914_18864)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M483.33 823.5L461.034 845.787L483.33 868.073L505.626 845.787L483.33 823.5Z",
    fill: "#32DCDC",
    fillOpacity: 0.2
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask137_914_18864",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 609,
    y: 811,
    width: 23,
    height: 23
  }, _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M625.291 811.257L609.59 826.952L615.872 833.23L631.573 817.536L625.291 811.257Z",
    fill: "white"
  }))), _g135 || (_g135 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask137_914_18864)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M620.586 799.958L598.29 822.245L620.586 844.532L642.882 822.245L620.586 799.958Z",
    fill: "#32DCDC",
    fillOpacity: 0.2
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask138_914_18864",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 586,
    y: 834,
    width: 23,
    height: 23
  }, _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M601.742 834.8L586.041 850.494L592.323 856.773L608.024 841.078L601.742 834.8Z",
    fill: "white"
  }))), _g136 || (_g136 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask138_914_18864)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M597.034 823.501L574.738 845.788L597.034 868.074L619.329 845.788L597.034 823.501Z",
    fill: "#32DCDC",
    fillOpacity: 0.2
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask139_914_18864",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 586,
    y: 811,
    width: 23,
    height: 23
  }, _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M592.325 811.257L586.044 817.536L601.745 833.23L608.026 826.951L592.325 811.257Z",
    fill: "white"
  }))), _g137 || (_g137 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask139_914_18864)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M597.034 799.958L574.738 822.245L597.034 844.532L619.33 822.245L597.034 799.958Z",
    fill: "#32DCDC",
    fillOpacity: 0.2
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask140_914_18864",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 609,
    y: 834,
    width: 23,
    height: 23
  }, _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M615.878 834.8L609.596 841.079L625.297 856.773L631.578 850.494L615.878 834.8Z",
    fill: "white"
  }))), _g138 || (_g138 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask140_914_18864)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M620.586 823.501L598.29 845.788L620.586 868.074L642.882 845.788L620.586 823.501Z",
    fill: "#32DCDC",
    fillOpacity: 0.2
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_914_18864"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 670,
    height: 900,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackgroundStep1);
export default __webpack_public_path__ + "static/media/background-step-1.b46de48256b3d82d8bdecd4bc7f7f281.svg";
export { ForwardRef as ReactComponent };